function themeElement() {
  if (document.body?.getAttribute("data-bs-theme")) return document.body
  return document.documentElement
}

export function readGoogleMapsColorScheme() {
  const isDark = themeElement().getAttribute("data-bs-theme") === "dark"

  if (typeof google !== "undefined" && google.maps?.ColorScheme) {
    return isDark ? google.maps.ColorScheme.DARK : google.maps.ColorScheme.LIGHT
  }

  return isDark ? "DARK" : "LIGHT"
}

export function observeGoogleMapsTheme(callback) {
  const handler = () => callback(readGoogleMapsColorScheme())
  document.addEventListener("depozen:theme-changed", handler)
  return () => document.removeEventListener("depozen:theme-changed", handler)
}
